import { render } from "./AvailmentSOAModal.vue?vue&type=template&id=ed40b154&scoped=true"
import script from "./AvailmentSOAModal.vue?vue&type=script&lang=js"
export * from "./AvailmentSOAModal.vue?vue&type=script&lang=js"

import "./AvailmentSOAModal.vue?vue&type=style&index=0&id=ed40b154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed40b154"]])

export default __exports__